export enum SolMgrFileType {
  Onboard= 1,
  Maintenance = 2
}
